import dayjs from "dayjs";
import { Bar, BarChart, CartesianGrid, LabelList, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

export default function MetricasGraficoBarraDias({ despesas, dataInicial, dataFinal, handleDiaSelecionado }: iProps) {

    if (despesas.length === 0) {
        return (
            <div>

            </div>
        )
    }

    const estatisticas = gerarEstatisticas(dataInicial, dataFinal, despesas);

    const labelQtdDespesas = (props: any) => {
        const { x, y, width, value } = props;
        const radius = 10;
        let positionY = (y - radius) - 10
        if (positionY < 10) {
            positionY = y
        }
        if (positionY >= 320) {
            positionY = positionY - 12
        }
        let valor = value
        if (Number(value) === 0) {
            valor = ""
        }
        return (
            <g>
                <text x={x + width / 2} y={positionY} fill="#000" textAnchor="middle" dominantBaseline="middle">
                    {valor}
                </text>
            </g>
        );
    };

    const labelValoresDespesas: any = ({ x, y, stroke, value }: any) => {
        let valor = Number(value) === 0 ? '' : moneyFormatter.format(value)
        const valorString = valor.substring(2, valor.length)

        let positionX = x
        switch (valorString.length) {
            case 7:
                positionX = x - 3
                break;
            case 8:
                positionX = x - 5
                break;
            case 9:
                positionX = x - 10
                break;
            case 10:
                positionX = x - 15
                break;
            case 11:
                positionX = x - 20
                break;
            case 12:
                positionX = x - 25
                break;
            default:
                positionX = x
                break;
        }

        let positionY = y + 10
        if (y > 310) {
            positionY = 330
            valor = valor.substring(2, valor.length)
            positionX = positionX + 6
        }

        return (
            <text x={positionX} y={positionY} fill={stroke} fontSize={12} style={{ fontWeight: "bold" }} dominantBaseline="middle" >
                {valor}
            </text >
        );
    };

    return (
        <div>
            <p style={{ textAlign: "right", fontWeight: "bold" }}>Quantidade de Despesas X Dias do Mês</p>
            <div id="graph_horas" className="graph_backgrounds" style={{ width: "100%", margin: "10px 0px 10px 0px" }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={300}
                        data={estatisticas}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="data_dia" />
                        <YAxis dataKey="valor_raw" />
                        <Tooltip />
                        <Bar
                            dataKey="valor_raw"
                            fill="#128FE2"
                            color="#AA0000"
                            activeBar={<Rectangle fill="gold" stroke="purple" />}
                            onClick={(event) => { handleDiaSelecionado(event) }}
                            label={labelValoresDespesas}
                        >
                            <LabelList dataKey="qtd" content={labelQtdDespesas} />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}
interface iProps {
    despesas: any[]
    dataInicial: string
    dataFinal: string
    handleDiaSelecionado: any
}

const moneyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

function gerarEstatisticas(dataInicial: string, dataFinal: string, despesas: any[]) {
    const inicio = dayjs(dataInicial);
    const fim = dayjs(dataFinal);
    let dias: any[] = [];

    if (fim < inicio) return [];

    // 1️⃣ Cria o array de dias
    for (let d = inicio; d <= fim; d = d.add(1, 'day')) {
        const dia = d.format("DD"); // apenas o número do dia
        const duplicado = dias.filter(reg => reg.data_dia === dia).length > 0 ? true : false
        if (duplicado) { continue }
        dias.push({
            data_dia: dia,
            qtd: 0,
            porcentagem_qtd: 0,
            valor: 0,
            valor_raw: 0,
            porcentagem_valor: 0
        });
    }

    // 2️⃣ Agrupa as despesas por dia
    let totalQtd = 0
    let totalValor = "0.00"
    despesas.forEach(despesa => {
        totalQtd += 1
        totalValor = Number(Number(totalValor) + Number(despesa.valor)).toFixed(2);
        let dataDespesa = dayjs(despesa.data_pagamento)
        if (despesa.data_pagamento === null || despesa.data_pagamento === "") {
            dataDespesa = dayjs(despesa.data_despesa);
        }
        const dia = dataDespesa.format("DD");
        const diaObj = dias.find(d => d.data_dia === dia);
        if (diaObj) {
            diaObj.qtd += 1;
            diaObj.valor = Number(Number(diaObj.valor) + Number(despesa.valor)).toFixed(2);
        }
    });

    // 3️⃣ Calcula porcentagens
    let diasAux: any[] = []
    dias.forEach(dia => {
        if (dia.qtd > 0) {
            diasAux.push(dia)
        }
        dia.porcentagem_qtd = totalQtd ? ((dia.qtd / totalQtd) * 100).toFixed(2) : 0;
        dia.porcentagem_valor = totalValor ? ((Number(dia.valor) / Number(totalValor)) * 100).toFixed(2) : 0;
        if (Number(dia.valor) > 0) {
            dia.valor_raw = Number(dia.valor)
            dia.valor = moneyFormatter.format(dia.valor)
        } else {
            dia.valor_raw = 0
        }
    });

    // return diasAux;
    return dias;
}
